import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ViConfirmDialogService } from '@vi-iot/ui';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-installation-migration-modal',
  templateUrl: './installation-migration-modal.component.html',
  styleUrls: ['./installation-migration-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationMigrationModalComponent {
  public currentStep = 0;

  constructor(
    private translateService: TranslateService,
    private viConfirmDialogService: ViConfirmDialogService,
    private matDialog: MatDialogRef<InstallationMigrationModalComponent>
  ) {}

  openMigrationSuccessModal(): void {
    this.matDialog.close();
    const modalContent = {
      title: this.translateService.instant('+INSTALLATIONS_MIGRATION.SUCCESS'),
      content: this.translateService.instant('+INSTALLATIONS_MIGRATION.SUCCESS_DESCRIPTION'),
      confirmBtn: this.translateService.instant('GENERAL.BUTTON.CLOSE'),
      cancelBtn: null,
    };
    this.viConfirmDialogService.open(modalContent);
  }
}
